module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAIElEQVQ4T2NgGBxglud/dIwBKhkw8KgBowYMNgOGNAAAKjOef743ULIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/IE.png
// module id = 1166
// module chunks = 0